export default __webpack_public_path__ + "static/media/banner-1.33b95d88.png";